import "./Services.css";

const Services = () => {
    return (
        <div className="services-container" id="services">
            <div className="services-heading">
                <h1>A Full Service Holistic <br /> <span>Bespoke & Collaborative</span> Approach.</h1>
            </div>
            <div className="services-inner-container">
                <div className="services">
                    <span>01</span>
                    <div className="service">
                        <h6>Website Development</h6>
                        <p>
                            We craft high-performance, scalable, and visually engaging websites that are built to convert. From corporate websites to advanced e-commerce platforms, Pinnate ensures every website is fast, responsive, and optimized for the best user experience.
                        </p>
                    </div>
                </div>
                <div className="services">
                    <span>02</span>
                    <div className="service">
                        <h6>UI/UX Design</h6>
                        <p>
                            Our design philosophy blends creativity with functionality. Through in-depth user research, wireframing, and prototyping, we craft seamless digital experiences that are intuitive, engaging, and conversion-focused. With Pinnate, design goes beyond aesthetics—it becomes a strategic growth driver.
                        </p>
                    </div>
                </div>
                <div className="services">
                    <span>03</span>
                    <div className="service">
                        <h6>AI Solutions & Automation</h6>
                        <p>
                         We develop intelligent AI-powered solutions that go beyond automation. From smart chatbots and virtual assistants to predictive analytics and workflow automation, our AI-driven systems enhance customer experiences, improve decision-making, and free up time for what matters most.
                        </p>
                    </div>
                </div>
                <div className="services">
                    <span>04</span>
                    <div className="service">
                        <h6>App Development</h6>
                        <p>
                            We design and develop mobile applications that are intuitive, secure, and scalable. Whether it’s Android, iOS, or cross-platform, our apps empower businesses to connect with their audiences seamlessly and deliver real value on the go.
                        </p>
                    </div>
                </div>
                <div className="services">
                    <span>05</span>
                    <div className="service">
                        <h6>SEO & AIO (AI Optimization)</h6>
                        <p>
                            Going beyond traditional SEO, we integrate AI-powered optimization to boost your online visibility, enhance search rankings, and personalize user experiences. Our hybrid SEO+AIO strategy ensures your business is discoverable, relevant, and future-ready.
                        </p>
                    </div>
                </div>
                <div className="services">
                    <span>06</span>
                    <div className="service">
                        <h6>Software Development</h6>
                        <p>
                            From enterprise solutions to custom tools, Pinnate builds software that simplifies complex processes, improves efficiency, and accelerates business growth. Every solution is tailored to your unique workflow and long-term goals.
                        </p>
                    </div>
                </div>
                <div className="services">
                    <span>07</span>
                    <div className="service">
                        <h6>Maintenance & Support</h6>
                        <p>
                            We don’t just build—we care for what we create. Our dedicated maintenance and support services keep your websites, apps, and software running smoothly with regular updates, performance monitoring, bug fixes, and security enhancements. With Pinnate, your digital assets are always future-proof.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services;
